export const Abilities: {[k: string]: ModdedAbilityData} = {
	asoneglastrier: {
		inherit: true,
		isNonstandard: "Past",
	},
	asonespectrier: {
		inherit: true,
		isNonstandard: "Past",
	},
	chillingneigh: {
		inherit: true,
		isNonstandard: "Past",
	},
	curiousmedicine: {
		inherit: true,
		isNonstandard: "Past",
	},
	dragonsmaw: {
		inherit: true,
		isNonstandard: "Past",
	},
	grimneigh: {
		inherit: true,
		isNonstandard: "Past",
	},
	quickdraw: {
		inherit: true,
		isNonstandard: "Past",
	},
	transistor: {
		inherit: true,
		isNonstandard: "Past",
	},
	unseenfist: {
		inherit: true,
		isNonstandard: "Past",
	},
};
